import { render, staticRenderFns } from "./furnitureshop-card-step.vue?vue&type=template&id=3a15ba97&scoped=true&"
import script from "./furnitureshop-card-step.vue?vue&type=script&lang=js&"
export * from "./furnitureshop-card-step.vue?vue&type=script&lang=js&"
import style0 from "./furnitureshop-card-step.vue?vue&type=style&index=0&id=3a15ba97&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a15ba97",
  null
  
)

export default component.exports